import { render, staticRenderFns } from "./dilalog-img.vue?vue&type=template&id=70483e22&scoped=true&"
import script from "./dilalog-img.vue?vue&type=script&lang=js&"
export * from "./dilalog-img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70483e22",
  null
  
)

export default component.exports